<template>
  <div :class="['container-3', `property-1-0-${property1}`, className]">
    <div class="frame-39">
      <img
        class="badge-euro-sign"
        alt="Badge euro"
        :src="badgeEuroSrc"
      />
      <div class="frame-40">
        <div class="text-wrapper-22">Rentabilité accrue</div>
        <p class="text-wrapper-23">
          Optimisez vos ventes et réduisez les coûts avec une gestion efficace
          de votre inventaire et de vos commandes.
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "Container3",
  props: {
    property1: {
      type: String as PropType<"variant-2" | "default">,
      required: true,
    },
    className: {
      type: String,
      default: "",
    },
    badgeEuroSign: {
      type: String,
      default: "",
    },
  },
  computed: {
    badgeEuroSrc(): string {
      const publicBase = process.env.BASE_URL || "/";
      return this.badgeEuroSign || `${publicBase}assets/icons/badge-euro-sign.svg`;
    },
  },
});
</script>

<style>
.container-3 {
  align-items: center;
  background-color: #d2f1ba;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: auto;
  justify-content: center;
  left: unset;
  max-width: none;
  min-height: 212px;
  padding: 30px;
  position: relative;
  width: 100%;
}

.container-3 .frame-39 {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 18px;
  position: relative;
  width: 100%;
}

.container-3 .badge-euro-sign {
  height: 32px;
  position: relative;
  width: 32px;
}

.container-3 .frame-40 {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 14px;
  position: relative;
  width: 100%;
}

.container-3 .text-wrapper-22 {
  align-self: stretch;
  color: #1a1a1a;
  font-family: "Montserrat", Helvetica;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 28px;
  margin-top: -1.00px;
  position: relative;
}

.container-3 .text-wrapper-23 {
  align-self: stretch;
  color: #313131;
  font-family: "Open Sans", Helvetica;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 20px;
  position: relative;
  text-align: center;
}

.container-3.property-1-0-default {
  border: 0px none;
  box-shadow: 0px 0px 0px transparent, 0px 1px 2px #0000000d;
  top: unset;
}

.container-3.property-1-0-variant-2 {
  box-shadow: 0px 1px 6px #08473440;
  top: unset;
}

@media (max-width: 768px) {
  .container-3 {
    min-height: 0;
    padding: 20px 16px;
  }
}
</style>
